// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"6f15d4f6","404":"e8442292","498":"6e3ea2b8","787":"45cf581f"}[chunkId] + ".chunk.js";
};